(function () {
  'use strict';
  var SHORT = [[/\bPavement\b/i, 'Pvmt']];

  function lineCount(el) {
    var r = document.createRange();
    r.selectNodeContents(el);
    var tops = {};
    Array.prototype.forEach.call(r.getClientRects(), function (b) {
      if (b.width > 0) tops[Math.round(b.top)] = 1;
    });
    return Object.keys(tops).length;
  }
  function box(el) {
    var p = el.parentElement;
    while (p && getComputedStyle(p).display === 'contents') p = p.parentElement;
    return p;
  }
  function tooLong(el) {
    if (!el.offsetWidth) return false;
    if (lineCount(el) > 1 || el.scrollWidth > el.clientWidth + 1) return true;
    var p = box(el);
    if (p && el.getBoundingClientRect().right > p.getBoundingClientRect().right + 1) return true;
    var direct = el.parentElement, next = el.nextElementSibling;
    if (!next || !direct) return false;
    var cs = getComputedStyle(direct);
    return cs.display.indexOf('flex') !== -1 && cs.flexDirection.indexOf('row') === 0 &&
      next.offsetTop >= el.offsetTop + el.offsetHeight / 2;
  }
  function fit(el) {
    var full = el.getAttribute('data-fit-name');
    var short = full;
    SHORT.forEach(function (s) { short = short.replace(s[0], s[1]); });
    if (short === full) return;
    if (el.textContent !== full) el.textContent = full;
    if (!tooLong(el)) return;
    el.textContent = '';
    var vis = document.createElement('span');
    vis.setAttribute('aria-hidden', 'true');
    vis.textContent = short;
    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = full;
    el.appendChild(vis);
    el.appendChild(sr);
  }
  var ro = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    entries.forEach(function (e) {
      Array.prototype.forEach.call(e.target.querySelectorAll('[data-fit-name]'), fit);
    });
  }) : null;
  function scan(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-fit-name]'), function (el) {
      var p = box(el);
      if (ro && p) ro.observe(p);
      fit(el);
    });
  }
  window.AlatreyuFitName = scan;
  if (!ro) window.addEventListener('resize', function () { scan(document); });
  scan(document);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { scan(document); });
})();
